/* @flow */
import gql from 'graphql-tag';
import {fragments as destinationBreadcrumbsFragments} from '../components/Breadcrumb/Breadcrumb';
import {fragments as hitCollectionFragments} from '../components/HitCollection/HitCollection';
import {fragments as mapFragments} from '../components/Map/Map';
import {fragments as pagerFragments} from '../components/Pager/Pager';
import {fragments as destinationMessage} from '../components/SearchBannerContainer/destinationMessage';
import {fragments as filterCountsFragments} from '../../universal/queries/filteredCountQuery';
import {fragments as expandedGroupsFragments} from '../components/ExpandedGroups/ExpandedGroups';
import {fragments as analyticsDataLayerFragments} from '../components/AnalyticsDataLayer/AnalyticsDataLayer';
import {fragments as searchTermCarouselFragments} from '../components/SearchTermCarousel/SearchTermCarousel';
import {fragments as seoContentFragment} from '../components/SeoContent/SeoContent';
import {fragments as internalToolsFragments} from '../components/InternalTools/InternalTools';
import {fragments as seoMetaDataParamsFragments} from '../components/withSeoMetaData/withSeoMetaData';
import transformSrsParamsToGts from '../../server/graphql/transformers/transformSrsParamsToGts';
import type {SearchParamsType} from '../reducers/searchParams';
import {querySelectionSet} from './searchQuery';
import {VRBO_WEB_SERP_FEWER_INITIAL_RESULTS} from '../../universal/abacus/experiments';

export const searchRequestQueryVariablesOverrides = (
    params: SearchParamsType,
    abacus: any
): SearchParamsType => {
    const reducedPageSizeExperiment =
        abacus[VRBO_WEB_SERP_FEWER_INITIAL_RESULTS] || {};
    const {bucketValue} = reducedPageSizeExperiment.bucket || {};
    let newParams: SearchParamsType = params;

    if (bucketValue > 0) {
        newParams = {
            ...params,
            pageSize: 25
        };
    }

    return newParams;
};

export const searchRequestQueryVariables = (
    params: SearchParamsType,
    isBot: boolean,
    abacus: any
) => {
    const newParams = searchRequestQueryVariablesOverrides(params, abacus);
    return {
        request: transformSrsParamsToGts(newParams),
        gtsQuery: true,
        isBot
    };
};

export const SEARCH_REQUEST_QUERY_NAME = 'SearchRequestQuery';

const searchRequestQuery = gql`
    query ${SEARCH_REQUEST_QUERY_NAME}($request: SearchResultRequest!, $gtsQuery: Boolean!, $isBot: Boolean!) {
        results: search(request: $request) {
            ${querySelectionSet}
            ...DestinationBreadcrumbsSearchResult
            ...DestinationMessageSearchResult
            ...FilterCountsSearchResult
            ...HitCollectionSearchResult
            ...ADLSearchResult
            ...MapSearchResult
            ...ExpandedGroupsSearchResult
            ...PagerSearchResult
            ...SearchTermCarouselSearchResult
            ...SeoContentSearchResult
            ...InternalToolsSearchResult
            ...SEOMetaDataParamsSearchResult
        }
        ...RequestMarkerFragment
    }
    ${destinationBreadcrumbsFragments.searchResult}
    ${hitCollectionFragments.searchResult}
    ${expandedGroupsFragments.searchResult}
    ${filterCountsFragments.searchResult}
    ${mapFragments.searchResult}
    ${pagerFragments.searchResult}
    ${destinationMessage.searchResult}
    ${analyticsDataLayerFragments.searchResult}
    ${analyticsDataLayerFragments.query}
    ${searchTermCarouselFragments.searchResult}
    ${seoContentFragment.searchResult}
    ${internalToolsFragments.searchResult}
    ${seoMetaDataParamsFragments.searchResult}
`;

export default searchRequestQuery;
